<div>
    <editor [apiKey]="apiKey" [(ngModel)]="htmlContent" ngDefaultControl
        [init]="config">
    </editor>
</div>
<div class="fullrow float-right mar-tb-16" *ngIf="!hideButtons">
    <button class="mat-stroked-button mar-r-16 " (click)="closeEditor()">
        Cancel
    </button>
    <button mat-flat-button class="mar-r-16 blue-1-button" (click)="saveContent()">
        Save changes
    </button>
</div>